// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"1dab2c47","243":"1dab2c47","353":"fe9c079c"}[chunkId] + ".chunk.css";
};